export function SortNew(jobType) {
    return {
        type: 'print/jobSort/SORT_NEW',
        payload: jobType,
    };
}

export function SortOld(jobType) {
    return {
        type: 'print/jobSort/SORT_OLD',
        payload: jobType,
    };
}

export function SortAtoZ(jobType) {
    return {
        type: 'print/jobSort/SORT_AZ',
        payload: jobType,
    };
}

export function newSearch(term, jobType) {
    return {
        type: 'print/new/SEARCH',
        term: term,
        jobType: jobType,
    };
}

export function fullSearch(term, jobType) {
    return {
        type: 'print/full/SEARCH',
        term: term,
        jobType: jobType,
    };
}

export function completeSearch(term, jobType) {
    return {
        type: 'print/complete/SEARCH',
        term: term,
        jobType: jobType,
    };
}
